import PropTypes from 'prop-types';
import React from 'react';

const Node = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.12" cx="1538" cy="563" r="124" fill="url(#paint0_linear_1112_9636)" />
    <circle opacity="0.12" cx="1538" cy="563" r="104" fill="url(#paint1_linear_1112_9636)" />
    <mask
      id="mask0_1112_9636"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1434"
      y="459"
      width="208"
      height="208"
    >
      <circle cx="1538" cy="563" r="104" fill="#181A1B" />
    </mask>
    <g mask="url(#mask0_1112_9636)">
      <g opacity="0.8">
        <path
          d="M1882.99 505.5H1865.88C1857.63 505.5 1849.39 505.5 1841.15 505.5C1832.76 505.5 1824.38 505.474 1815.99 505.42C1807.42 505.42 1798.85 505.377 1790.28 505.29C1781.46 505.237 1772.64 505.167 1763.83 505.08L1755.04 504.99C1748.81 504.91 1742.58 504.814 1736.36 504.7C1726.71 504.52 1717.05 504.277 1707.36 503.97C1697.07 503.64 1687.06 503.24 1676.79 502.73H1676C1663.87 502.12 1652.42 501.41 1640.3 500.55C1634.76 500.15 1629.22 499.734 1623.67 499.3L1608.91 498.1L1594.15 496.88C1590.15 496.554 1586.15 496.22 1582.15 495.88C1576.15 495.42 1570.15 494.99 1564.1 494.63C1558.05 494.27 1552.1 493.98 1546.01 493.78C1534.33 493.41 1523.15 493.41 1511.47 493.78C1505.41 493.98 1499.41 494.27 1493.38 494.63C1487.35 494.99 1481.33 495.43 1475.32 495.89C1471.32 496.204 1467.32 496.537 1463.32 496.89L1448.55 498.07L1433.79 499.27C1428.25 499.71 1422.7 500.13 1417.15 500.53C1405.04 501.39 1393.59 502.1 1381.46 502.72H1380.68C1370.39 503.24 1360.39 503.64 1350.1 503.98C1340.44 504.294 1330.77 504.537 1321.1 504.71C1314.88 504.83 1308.66 504.93 1302.43 505.01L1293.62 505.11C1284.8 505.204 1275.98 505.274 1267.15 505.32C1258.56 505.38 1249.97 505.43 1241.39 505.47L1216.15 505.55H1197"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 657.899H1881.82L1859.7 657.829C1852.33 657.789 1844.96 657.743 1837.58 657.689C1830.2 657.636 1822.83 657.569 1815.47 657.489C1808.09 657.389 1800.72 657.279 1793.35 657.099C1785.98 656.919 1778.6 656.699 1771.24 656.369C1763.88 656.039 1756.5 655.639 1749.16 655.089C1741.82 654.539 1734.46 653.829 1727.16 652.899C1723.51 652.439 1719.87 651.913 1716.25 651.319C1712.63 650.726 1709.03 650.029 1705.44 649.229C1698.29 647.694 1691.27 645.622 1684.44 643.029C1677.74 640.423 1671.29 637.234 1665.15 633.499C1659.12 629.747 1653.29 625.667 1647.7 621.279C1644.89 619.119 1642.1 616.929 1639.3 614.759C1636.5 612.589 1633.7 610.419 1630.83 608.319C1625.09 604.06 1619.08 600.185 1612.83 596.719C1606.43 593.236 1599.74 590.328 1592.83 588.029C1590.67 587.323 1588.49 586.656 1586.3 586.029C1581.33 584.691 1576.28 583.623 1571.19 582.829C1568.72 582.449 1566.23 582.116 1563.74 581.829C1561.24 581.559 1558.74 581.359 1556.23 581.199C1553.49 581.019 1550.76 580.899 1548.01 580.829L1545.61 580.779C1543.66 580.779 1541.75 580.779 1539.8 580.779C1538.48 580.779 1537.17 580.779 1535.85 580.779H1532.76H1530.08H1527.51H1524.83H1521.74H1517.8C1515.85 580.779 1513.94 580.779 1511.99 580.829H1509.61C1506.88 580.899 1504.12 580.999 1501.4 581.149C1498.85 581.279 1496.4 581.459 1493.83 581.689C1491.26 581.919 1488.83 582.219 1486.3 582.569C1481.23 583.287 1476.19 584.288 1471.23 585.569C1468.89 586.169 1466.57 586.849 1464.29 587.569C1457.3 589.848 1450.53 592.774 1444.08 596.309C1437.79 599.809 1431.76 603.749 1426.03 608.099C1423.17 610.229 1420.38 612.439 1417.6 614.649C1414.82 616.859 1412.08 619.109 1409.29 621.309C1403.74 625.8 1397.93 629.964 1391.89 633.779C1385.71 637.624 1379.17 640.878 1372.38 643.499C1365.48 646.077 1358.4 648.12 1351.19 649.609C1347.58 650.369 1343.94 651.029 1340.28 651.609C1336.62 652.189 1332.96 652.689 1329.28 653.139C1321.92 654.039 1314.54 654.719 1307.15 655.259C1299.76 655.799 1292.35 656.199 1284.93 656.519C1277.51 656.839 1270.11 657.049 1262.7 657.219C1255.29 657.389 1247.87 657.509 1240.46 657.599C1233.05 657.689 1225.63 657.749 1218.22 657.809L1197.05 657.939"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 627.42H1881.26L1859.1 627.34C1851.72 627.34 1844.33 627.297 1836.94 627.21C1829.55 627.123 1822.16 627.053 1814.78 627C1807.38 626.913 1799.99 626.787 1792.6 626.62C1785.2 626.44 1777.81 626.21 1770.42 625.89C1763.03 625.57 1755.63 625.15 1748.26 624.6C1740.89 624.05 1733.5 623.35 1726.16 622.42C1722.49 621.95 1718.83 621.42 1715.16 620.82C1711.49 620.22 1707.88 619.54 1704.28 618.74C1697.1 617.206 1690.05 615.134 1683.18 612.54C1676.41 609.929 1669.88 606.734 1663.67 602.99C1657.57 599.233 1651.67 595.15 1646 590.76C1643.15 588.61 1640.33 586.42 1637.5 584.26C1634.67 582.1 1631.79 579.91 1628.87 577.81C1622.99 573.531 1616.82 569.655 1610.41 566.21C1603.78 562.687 1596.84 559.772 1589.68 557.5C1586.68 556.56 1583.68 555.74 1580.68 555.01C1575.96 553.89 1571.18 553.01 1566.36 552.34C1564.44 552.07 1562.51 551.84 1560.57 551.63C1556.91 551.25 1553.26 550.99 1549.57 550.8C1547.09 550.67 1544.57 550.58 1542.11 550.52C1540.16 550.47 1538.22 550.43 1536.27 550.41H1531.19H1526.33C1524.64 550.41 1522.94 550.41 1521.25 550.46C1519.31 550.46 1517.36 550.51 1515.41 550.56C1512.92 550.63 1510.41 550.72 1507.95 550.84C1504.27 551.03 1500.61 551.3 1496.95 551.68C1495.02 551.88 1493.09 552.113 1491.16 552.38C1486.35 553.03 1481.53 553.89 1476.81 554.97C1473.72 555.68 1470.66 556.48 1467.64 557.4C1460.38 559.606 1453.35 562.492 1446.64 566.02C1440.18 569.469 1433.98 573.383 1428.08 577.73C1425.32 579.73 1422.61 581.82 1419.92 583.92C1416.92 586.25 1414 588.59 1411.02 590.92C1405.38 595.395 1399.49 599.552 1393.39 603.37C1387.15 607.188 1380.57 610.418 1373.73 613.02C1366.79 615.606 1359.65 617.652 1352.39 619.14C1348.76 619.91 1345.1 620.57 1341.39 621.14C1337.68 621.71 1334.02 622.23 1330.32 622.68C1322.93 623.58 1315.51 624.26 1308.08 624.81C1300.65 625.36 1293.23 625.75 1285.79 626.06C1278.35 626.37 1270.92 626.6 1263.48 626.77C1256.04 626.94 1248.61 627.05 1241.18 627.14C1233.75 627.23 1226.32 627.3 1218.89 627.35L1197.05 627.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 535.999H1880.91C1873.03 535.999 1865.15 535.999 1857.28 535.999C1849.41 535.999 1841.46 535.976 1833.43 535.929L1818.71 535.849L1809.3 535.799C1801.14 535.739 1792.98 535.666 1784.81 535.579C1776.49 535.486 1768.16 535.359 1759.81 535.199C1751.26 535.029 1742.81 534.789 1734.21 534.469C1725.33 534.139 1716.57 533.729 1707.7 533.189L1706.39 533.099C1697.49 532.549 1688.75 531.869 1679.88 530.999C1674.88 530.519 1669.88 529.999 1664.88 529.379C1659.88 528.759 1654.94 528.089 1649.97 527.379L1644.97 526.589C1635.33 525.029 1626.09 523.239 1616.58 521.169C1612.13 520.196 1607.69 519.196 1603.27 518.169L1588.73 514.809C1583.88 513.709 1579 512.619 1574.13 511.629L1570.66 510.949C1565.97 510.029 1561.28 509.219 1556.55 508.539C1551.82 507.859 1547.07 507.329 1542.28 506.969C1533.26 506.299 1524.2 506.299 1515.17 506.969C1510.38 507.319 1505.64 507.859 1500.9 508.539C1496.16 509.219 1491.48 510.039 1486.78 510.949L1483.32 511.639C1478.45 512.639 1473.57 513.709 1468.72 514.819C1463.87 515.929 1459.03 517.069 1454.18 518.199C1449.75 519.199 1445.32 520.199 1440.87 521.199C1431.35 523.279 1422.11 525.059 1412.47 526.629C1410.8 526.909 1409.14 527.159 1407.47 527.419C1402.47 528.179 1397.55 528.849 1392.56 529.419C1387.57 529.989 1382.56 530.579 1377.56 531.059C1368.68 531.919 1359.93 532.609 1351.03 533.169L1349.72 533.249C1340.85 533.799 1332.07 534.249 1323.19 534.549C1314.62 534.869 1306.1 535.109 1297.53 535.289C1289.18 535.456 1280.82 535.586 1272.47 535.679C1264.26 535.766 1256.05 535.836 1247.85 535.889L1238.58 535.959L1223.58 536.039L1199.58 536.119H1197.05"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 596.94H1876.99C1869.51 596.94 1862.03 596.913 1854.56 596.86C1847.09 596.807 1839.59 596.767 1832.07 596.74C1824.59 596.673 1817.08 596.593 1809.55 596.5L1803.77 596.43C1798.16 596.35 1792.55 596.247 1786.93 596.12C1779.36 595.94 1771.8 595.71 1764.23 595.39C1756.66 595.07 1749.03 594.66 1741.44 594.1C1733.85 593.54 1726.18 592.85 1718.58 591.92C1714.75 591.46 1710.94 590.93 1707.13 590.33C1703.32 589.72 1699.53 589.04 1695.77 588.25C1688.2 586.701 1680.74 584.626 1673.46 582.04C1668.87 580.385 1664.37 578.493 1659.98 576.37C1657.43 575.15 1654.98 573.85 1652.47 572.49C1645.71 568.75 1639.3 564.55 1632.97 560.27C1629.72 558.08 1626.48 555.86 1623.22 553.68C1619.96 551.5 1616.66 549.37 1613.29 547.32C1611.92 546.48 1610.55 545.67 1609.16 544.87C1603.12 541.384 1596.85 538.326 1590.38 535.72C1587.38 534.53 1584.38 533.46 1581.38 532.48C1575.21 530.523 1568.92 528.976 1562.55 527.85C1560.92 527.55 1559.28 527.28 1557.63 527.04C1554.37 526.55 1551.08 526.16 1547.8 525.85C1543.54 525.45 1539.23 525.19 1534.95 525.06C1530.87 524.95 1526.75 524.95 1522.67 525.06C1518.4 525.19 1514.09 525.45 1509.83 525.85C1506.54 526.16 1503.25 526.55 1499.99 527.04C1498.35 527.28 1496.7 527.55 1495.07 527.85C1488.66 528.98 1482.34 530.533 1476.14 532.5C1473.08 533.5 1470.07 534.55 1467.14 535.74C1460.67 538.346 1454.4 541.407 1448.36 544.9C1446.97 545.7 1445.59 546.51 1444.22 547.35C1440.85 549.4 1437.56 551.53 1434.28 553.72C1431 555.91 1427.77 558.11 1424.52 560.31C1418.17 564.6 1411.73 568.83 1404.97 572.59C1402.51 573.95 1400.02 575.25 1397.48 576.47C1393.04 578.625 1388.49 580.545 1383.85 582.22C1376.5 584.851 1368.96 586.95 1361.31 588.5C1357.51 589.28 1353.69 589.967 1349.84 590.56C1345.99 591.153 1342.14 591.68 1338.27 592.14C1330.61 593.06 1322.92 593.75 1315.21 594.3C1307.5 594.85 1299.9 595.3 1292.21 595.58C1284.52 595.86 1276.96 596.12 1269.33 596.29C1264.04 596.417 1258.74 596.513 1253.45 596.58L1246.55 596.67C1238.99 596.77 1231.43 596.84 1223.86 596.88C1216.29 596.92 1208.75 596.967 1201.23 597.02H1197.05"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 566.501C1878.36 566.501 1873.74 566.501 1869.12 566.501C1861.46 566.501 1853.79 566.477 1846.12 566.431C1838.45 566.384 1830.74 566.341 1823 566.301C1815.24 566.247 1807.48 566.177 1799.72 566.091C1791.89 565.991 1784.06 565.881 1776.23 565.701C1768.4 565.521 1760.39 565.301 1752.47 564.981C1748.1 564.801 1743.71 564.601 1739.34 564.361C1735.68 564.161 1732.01 563.937 1728.34 563.691C1720.13 563.131 1711.99 562.431 1703.82 561.511C1699.63 561.044 1695.45 560.507 1691.29 559.901C1687.13 559.294 1682.98 558.607 1678.84 557.841C1671.72 556.491 1664.68 554.841 1657.74 552.841C1656.35 552.441 1654.97 552.031 1653.6 551.601C1645.07 548.899 1636.71 545.7 1628.55 542.021C1625.96 540.861 1623.39 539.671 1620.82 538.461C1618.25 537.251 1615.71 536.001 1613.17 534.771C1609.75 533.111 1606.34 531.441 1602.91 529.771C1596.3 526.611 1589.76 523.651 1582.91 521.001C1578.91 519.461 1574.91 518.061 1570.74 516.821C1566.95 515.671 1563.12 514.681 1559.22 513.821C1555.84 513.087 1552.43 512.471 1548.99 511.971C1545.55 511.481 1542.08 511.101 1538.61 510.861C1532.05 510.401 1525.47 510.401 1518.91 510.861C1515.44 511.114 1511.98 511.487 1508.54 511.981C1505.1 512.474 1501.69 513.091 1498.3 513.831C1494.41 514.677 1490.57 515.677 1486.78 516.831C1482.65 518.081 1478.62 519.471 1474.61 521.021C1467.73 523.671 1461.19 526.641 1454.61 529.801C1451.18 531.441 1447.77 533.107 1444.36 534.801C1441.81 536.041 1439.25 537.271 1436.7 538.491C1434.13 539.711 1431.56 540.901 1428.97 542.061C1420.8 545.734 1412.43 548.926 1403.89 551.621C1402.51 552.051 1401.13 552.461 1399.74 552.861C1392.8 554.861 1385.74 556.491 1378.62 557.861C1374.48 558.641 1370.32 559.334 1366.14 559.941C1361.96 560.547 1357.76 561.067 1353.55 561.501C1345.34 562.421 1337.16 563.131 1328.92 563.691C1325.29 563.944 1321.67 564.167 1318.04 564.361C1313.58 564.601 1309.13 564.801 1304.66 564.991C1296.66 565.311 1288.68 565.554 1280.72 565.721C1272.76 565.887 1264.86 566.017 1257.03 566.111C1249.2 566.204 1241.38 566.274 1233.55 566.321C1225.72 566.367 1217.95 566.427 1210.24 566.501H1197.05"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 475.02H1846.34C1837.55 475.02 1828.76 475.02 1819.97 475.02L1803.66 474.97H1792.81C1783.4 474.97 1773.98 474.927 1764.57 474.84C1754.65 474.78 1744.73 474.71 1734.81 474.63C1726.08 474.557 1717.35 474.46 1708.64 474.34L1702.7 474.25C1690.7 474.063 1678.67 473.82 1666.62 473.52C1659.12 473.34 1651.62 473.14 1644.11 472.92L1622.29 472.24C1612.75 471.94 1603.21 471.62 1593.66 471.34C1578.92 470.89 1564.49 470.52 1549.75 470.34C1535.55 470.15 1521.98 470.16 1507.75 470.34C1493 470.54 1478.57 470.92 1463.83 471.34C1454.29 471.63 1444.75 471.95 1435.21 472.25C1427.93 472.49 1420.65 472.717 1413.38 472.93C1405.88 473.157 1398.38 473.363 1390.88 473.55C1378.88 473.85 1366.85 474.097 1354.79 474.29L1348.86 474.38C1340.13 474.507 1331.41 474.607 1322.69 474.68C1312.76 474.78 1302.83 474.853 1292.91 474.9C1283.5 474.96 1274.08 475.01 1264.66 475.05H1253.82L1237.55 475.1H1211.16H1197.05"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 718.889H1871.99L1849.21 718.809C1841.58 718.809 1833.95 718.766 1826.32 718.679C1818.69 718.593 1811.03 718.523 1803.32 718.469C1795.6 718.383 1787.88 718.253 1780.16 718.079C1772.44 717.906 1764.65 717.666 1756.8 717.359C1748.91 717.029 1741.06 716.619 1733.19 716.069C1727.09 715.639 1721 715.129 1714.93 714.499C1713.05 714.313 1711.18 714.109 1709.31 713.889C1705.26 713.423 1701.22 712.889 1697.2 712.289C1693.2 711.679 1689.2 710.999 1685.2 710.219C1677.06 708.65 1669.02 706.576 1661.14 704.009C1654.92 701.945 1648.82 699.552 1642.86 696.839C1641.17 696.069 1639.48 695.269 1637.81 694.459C1635.87 693.509 1633.94 692.529 1632.03 691.539C1630.12 690.549 1628.21 689.539 1626.32 688.539C1622.53 686.479 1618.79 684.369 1615.02 682.279C1611.25 680.189 1607.35 678.019 1603.44 675.979C1598.91 673.599 1594.36 671.379 1589.64 669.319C1585.39 667.479 1581.09 665.819 1576.64 664.319C1569.8 662.034 1562.81 660.249 1555.71 658.979C1552.91 658.479 1550.09 658.049 1547.26 657.709C1544.02 657.319 1540.76 657.029 1537.5 656.839C1531.7 656.514 1525.89 656.514 1520.09 656.839C1516.82 657.019 1513.57 657.309 1510.32 657.709C1507.49 658.049 1504.67 658.473 1501.86 658.979C1494.76 660.253 1487.77 662.041 1480.94 664.329C1476.52 665.809 1472.21 667.479 1467.94 669.329C1463.21 671.379 1458.67 673.609 1454.13 675.979C1450.23 678.029 1446.39 680.149 1442.55 682.289C1438.71 684.429 1435.04 686.489 1431.25 688.559C1429.36 689.559 1427.45 690.559 1425.54 691.559C1423.63 692.559 1421.7 693.559 1419.75 694.479C1418.08 695.289 1416.4 696.089 1414.7 696.859C1408.73 699.582 1402.63 701.982 1396.41 704.049C1388.51 706.628 1380.45 708.709 1372.29 710.279C1368.29 711.069 1364.29 711.749 1360.22 712.359C1356.15 712.969 1352.11 713.489 1348.04 713.959C1346.21 714.179 1344.36 714.379 1342.51 714.569C1336.35 715.236 1330.18 715.763 1323.99 716.149C1316.06 716.709 1308.14 717.149 1300.19 717.449C1292.24 717.749 1284.49 717.999 1276.63 718.169C1268.77 718.339 1261.05 718.469 1253.27 718.559C1245.49 718.649 1237.8 718.719 1230.07 718.769C1222.34 718.819 1214.68 718.869 1206.99 718.909H1197.06"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1882.99 688.4H1878.73C1871.28 688.4 1863.84 688.373 1856.4 688.32C1848.96 688.267 1841.51 688.223 1834.05 688.19C1826.58 688.143 1819.11 688.073 1811.65 687.98C1804.19 687.887 1796.71 687.757 1789.22 687.59C1781.72 687.423 1774.22 687.183 1766.73 686.87C1761.99 686.67 1757.25 686.427 1752.52 686.14C1749.74 685.97 1746.96 685.79 1744.2 685.58C1736.66 685.02 1729.14 684.33 1721.65 683.4C1717.89 682.94 1714.13 682.4 1710.4 681.81C1706.67 681.22 1702.93 680.52 1699.24 679.73C1691.83 678.177 1684.54 676.095 1677.43 673.5C1670.39 670.886 1663.58 667.692 1657.07 663.95C1650.56 660.22 1644.41 656.02 1638.37 651.73C1637.42 651.06 1636.47 650.39 1635.53 649.73C1632.94 647.88 1630.36 646.02 1627.75 644.19C1625.14 642.36 1622.52 640.55 1619.84 638.79C1613.23 634.409 1606.3 630.531 1599.11 627.19C1597.48 626.45 1595.84 625.74 1594.18 625.06C1587.43 622.329 1580.48 620.135 1573.39 618.5L1571.56 618.1C1566.51 617 1561.37 616.16 1556.21 615.53C1552.21 615.04 1548.21 614.68 1544.21 614.43C1540.74 614.21 1537.21 614.06 1533.76 613.99C1530.44 613.92 1527.09 613.92 1523.76 613.99C1520.28 614.06 1516.76 614.21 1513.31 614.43C1509.31 614.69 1505.31 615.05 1501.31 615.54C1496.15 616.17 1491.01 617.01 1485.95 618.11L1484.13 618.52C1477.03 620.15 1470.08 622.344 1463.33 625.08C1461.67 625.76 1460.02 626.47 1458.4 627.21C1451.19 630.551 1444.24 634.428 1437.61 638.81C1434.93 640.56 1432.3 642.36 1429.69 644.19C1427.08 646.02 1424.5 647.88 1421.92 649.73L1419.01 651.81C1412.95 656.12 1406.76 660.38 1400.24 664.15C1393.69 667.941 1386.82 671.169 1379.72 673.8C1372.55 676.401 1365.2 678.474 1357.72 680C1353.98 680.78 1350.22 681.45 1346.45 682.05C1342.68 682.65 1338.88 683.15 1335.08 683.6C1327.53 684.51 1319.95 685.2 1312.35 685.75C1309.85 685.93 1307.35 686.09 1304.84 686.25C1299.79 686.55 1294.72 686.803 1289.65 687.01C1282.11 687.33 1274.57 687.57 1267.02 687.73C1259.47 687.89 1251.95 688.013 1244.44 688.1C1236.93 688.193 1229.41 688.263 1221.9 688.31C1214.39 688.357 1206.89 688.4 1199.42 688.44L1197.05 688.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="20"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="1492.34" y="506">
        MEMORY
      </tspan>
    </text>
    <text
      fill="url(#paint2_linear_1112_9636)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="76"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="1459.46" y="579.6">
        29%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="1499.2" y="610.8">
        Address:&#10;
      </tspan>
      <tspan x="1494.26" y="633.8">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_9636)">
      <rect x="600" y="304" width="696" height="430" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="600" y="377" width="696" height="24" fill="#FD0054" />
    <rect opacity="0.1" x="649" y="341" width="1" height="393" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="616.184" y="372.938">
        36&#10;
      </tspan>
      <tspan x="616.184" y="393.938">
        37&#10;
      </tspan>
      <tspan x="616.184" y="414.938">
        38&#10;
      </tspan>
      <tspan x="616.184" y="435.938">
        39&#10;
      </tspan>
      <tspan x="616.184" y="456.938">
        40&#10;
      </tspan>
      <tspan x="616.184" y="477.938">
        41&#10;
      </tspan>
      <tspan x="616.184" y="498.938">
        42&#10;
      </tspan>
      <tspan x="616.184" y="519.938">
        43&#10;
      </tspan>
      <tspan x="616.184" y="540.938">
        44&#10;
      </tspan>
      <tspan x="616.184" y="561.938">
        45&#10;
      </tspan>
      <tspan x="616.184" y="582.938">
        46&#10;
      </tspan>
      <tspan x="616.184" y="603.938">
        47&#10;
      </tspan>
      <tspan x="616.184" y="624.938">
        48&#10;
      </tspan>
      <tspan x="616.184" y="645.938">
        49&#10;
      </tspan>
      <tspan x="616.184" y="666.938">
        50&#10;
      </tspan>
      <tspan x="616.184" y="687.938">
        51&#10;
      </tspan>
      <tspan x="616.184" y="708.938">
        52
      </tspan>
    </text>
    <path
      d="M600 316C600 309.373 605.373 304 612 304H1284C1290.63 304 1296 309.373 1296 316V340H600V316Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="922.243" y="326.9">
        Node.js
      </tspan>
    </text>
    <circle cx="622" cy="322" r="6" fill="#FD0054" />
    <circle cx="642" cy="322" r="6" fill="#FFB31A" />
    <circle cx="662" cy="322" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="600" y="340" width="696" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="674" y="372.938">
        app.
      </tspan>
      <tspan x="732.857" y="372.938">
        (&apos;/search/:query?&apos;,{' '}
      </tspan>
      <tspan x="968.287" y="372.938">
        (req, res){'{'}&#10;
      </tspan>
      <tspan x="674" y="393.938">
        {' '}
      </tspan>
      <tspan x="716.041" y="393.938">
        {' '}
        query = req.
      </tspan>
      <tspan x="926.246" y="393.938">
        ;&#10;
      </tspan>
      <tspan x="674" y="414.938">
        {'  '}
        db.
      </tspan>
      <tspan x="783.307" y="414.938">
        (query,{' '}
      </tspan>
      <tspan x="917.838" y="414.938">
        (err, vals){'{'}&#10;
      </tspan>
      <tspan x="674" y="435.938">
        {' '}
      </tspan>
      <tspan x="724.449" y="435.938">
        {' '}
        (err){' '}
      </tspan>
      <tspan x="833.756" y="435.938">
        {' '}
        res.
      </tspan>
      <tspan x="909.43" y="435.938">
        (
      </tspan>
      <tspan x="943.062" y="435.938">
        );&#10;
      </tspan>
      <tspan x="674" y="456.938">
        {'    '}
        res.
      </tspan>
      <tspan x="774.898" y="456.938">
        (vals);&#10;
      </tspan>
      <tspan x="674" y="477.938">
        {' '}
        {'}'});&#10;
      </tspan>
      <tspan x="674" y="498.938">
        {'}'});&#10;
      </tspan>
      <tspan x="674" y="519.938" />
      <tspan x="674" y="540.938">
        app.
      </tspan>
      <tspan x="732.857" y="540.938">
        (&apos;/client.js&apos;,{' '}
      </tspan>
      <tspan x="926.246" y="540.938">
        (req, res){'{'}&#10;
      </tspan>
      <tspan x="674" y="561.938">
        {'  '}
        res.
      </tspan>
      <tspan x="791.715" y="561.938">
        (path.
      </tspan>
      <tspan x="875.797" y="561.938">
        (__dirname, &apos;client.js&apos;));&#10;
      </tspan>
      <tspan x="674" y="582.938">
        {'}'});&#10;
      </tspan>
      <tspan x="674" y="603.938" />
      <tspan x="690.816" y="645.938">
        {' '}
        (!module.
      </tspan>
      <tspan x="825.348" y="645.938">
        ) {'{'}&#10;
      </tspan>
      <tspan x="674" y="666.938">
        {' '}
        app.
      </tspan>
      <tspan x="774.898" y="666.938">
        (
      </tspan>
      <tspan x="816.939" y="666.938">
        );&#10;
      </tspan>
      <tspan x="674" y="687.938">
        {' '}
        console.
      </tspan>
      <tspan x="783.307" y="687.938">
        (&apos;Express started on port 3000&apos;);&#10;
      </tspan>
      <tspan x="674" y="708.938">
        {'}'}
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="707.633" y="372.938">
        get
      </tspan>
      <tspan x="716.041" y="414.938">
        smembers
      </tspan>
      <tspan x="875.797" y="435.938">
        send
      </tspan>
      <tspan x="741.266" y="456.938">
        send
      </tspan>
      <tspan x="707.633" y="540.938">
        get
      </tspan>
      <tspan x="724.449" y="561.938">
        sendFile
      </tspan>
      <tspan x="842.164" y="561.938">
        join
      </tspan>
      <tspan x="724.449" y="666.938">
        listen
      </tspan>
      <tspan x="758.082" y="687.938">
        log
      </tspan>
    </text>
    <text
      fill="#00CCCC"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="825.348" y="393.938">
        params.query
      </tspan>
      <tspan x="917.838" y="435.938">
        500
      </tspan>
      <tspan x="774.898" y="645.938">
        parent
      </tspan>
      <tspan x="783.307" y="666.938">
        3000
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="901.021" y="372.938">
        function
      </tspan>
      <tspan x="690.816" y="393.938">
        var
      </tspan>
      <tspan x="850.572" y="414.938">
        function
      </tspan>
      <tspan x="707.633" y="435.938">
        if
      </tspan>
      <tspan x="783.307" y="435.938">
        return
      </tspan>
      <tspan x="858.98" y="540.938">
        function
      </tspan>
      <tspan x="674" y="645.938">
        if
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="674" y="624.938">
        /* istanbul ignore next */&#10;
      </tspan>
    </text>
    <g clipPath="url(#clip0_1112_9636)">
      <path
        d="M1261.59 690.778C1261.28 690.772 1260.97 690.846 1260.69 690.993L1252.07 695.874C1251.8 696.032 1251.57 696.257 1251.41 696.528C1251.26 696.799 1251.17 697.106 1251.18 697.418V707.161C1251.17 707.473 1251.26 707.779 1251.41 708.05C1251.57 708.321 1251.8 708.547 1252.07 708.705L1254.32 709.978C1255.42 710.507 1255.82 710.498 1256.32 710.498C1257.94 710.498 1258.86 709.535 1258.86 707.861V698.243C1258.86 698.211 1258.85 698.18 1258.84 698.151C1258.83 698.122 1258.81 698.096 1258.78 698.074C1258.76 698.052 1258.73 698.035 1258.7 698.024C1258.67 698.013 1258.64 698.008 1258.61 698.009H1257.53C1257.49 698.008 1257.46 698.013 1257.43 698.024C1257.4 698.035 1257.37 698.052 1257.35 698.073C1257.32 698.095 1257.3 698.121 1257.29 698.151C1257.28 698.18 1257.27 698.211 1257.27 698.243V707.862C1257.27 708.604 1256.48 709.35 1255.2 708.723L1252.86 707.377C1252.82 707.357 1252.78 707.327 1252.76 707.289C1252.73 707.251 1252.72 707.207 1252.71 707.162V697.418C1252.72 697.37 1252.73 697.324 1252.76 697.283C1252.78 697.243 1252.82 697.209 1252.86 697.185L1261.46 692.322C1261.5 692.3 1261.54 692.288 1261.59 692.288C1261.63 692.288 1261.68 692.3 1261.72 692.322L1270.32 697.184C1270.36 697.208 1270.4 697.242 1270.42 697.283C1270.45 697.323 1270.46 697.37 1270.47 697.418V707.161C1270.47 707.208 1270.45 707.253 1270.43 707.294C1270.41 707.335 1270.38 707.369 1270.34 707.394L1261.72 712.257C1261.68 712.278 1261.64 712.289 1261.59 712.289C1261.55 712.289 1261.5 712.278 1261.46 712.257L1259.25 710.966C1259.21 710.948 1259.18 710.938 1259.14 710.938C1259.1 710.938 1259.06 710.948 1259.03 710.966C1258.42 711.305 1258.3 711.344 1257.73 711.54C1257.59 711.588 1257.37 711.663 1257.8 711.899L1260.69 713.567C1260.97 713.72 1261.28 713.801 1261.59 713.801C1261.91 713.801 1262.21 713.72 1262.49 713.567L1271.11 708.704C1271.38 708.546 1271.61 708.32 1271.77 708.05C1271.92 707.779 1272 707.473 1272 707.161V697.418C1272 697.106 1271.92 696.799 1271.77 696.529C1271.61 696.258 1271.38 696.032 1271.11 695.874L1262.49 690.994C1262.21 690.846 1261.9 690.772 1261.59 690.778H1261.59Z"
        fill="#83CD29"
      />
      <path
        d="M1263.89 697.74C1261.44 697.74 1259.98 698.764 1259.98 700.468C1259.98 702.315 1261.43 702.823 1263.78 703.052C1266.6 703.322 1266.82 703.728 1266.82 704.269C1266.82 705.213 1266.05 705.615 1264.24 705.615C1261.96 705.615 1261.46 705.058 1261.29 703.947C1261.29 703.889 1261.26 703.835 1261.22 703.796C1261.17 703.756 1261.12 703.733 1261.06 703.731H1259.94C1259.87 703.733 1259.81 703.76 1259.76 703.807C1259.71 703.853 1259.68 703.917 1259.68 703.983C1259.68 705.405 1260.47 707.087 1264.24 707.087C1266.97 707.087 1268.54 706.035 1268.54 704.198C1268.54 702.374 1267.27 701.885 1264.62 701.541C1261.95 701.194 1261.7 701.024 1261.7 700.41C1261.7 699.904 1261.91 699.226 1263.89 699.226C1265.66 699.226 1266.31 699.6 1266.58 700.77C1266.59 700.824 1266.62 700.873 1266.67 700.909C1266.71 700.945 1266.76 700.965 1266.82 700.967H1267.94C1268.01 700.961 1268.07 700.929 1268.12 700.877C1268.14 700.854 1268.16 700.826 1268.18 700.795C1268.19 700.764 1268.19 700.731 1268.19 700.698C1268.02 698.684 1266.65 697.736 1263.89 697.736V697.74Z"
        fill="#83CD29"
      />
      <path
        d="M1210.92 678C1210.84 678 1210.77 678.013 1210.71 678.04C1210.64 678.067 1210.58 678.106 1210.53 678.156C1210.48 678.206 1210.43 678.266 1210.41 678.331C1210.38 678.397 1210.36 678.467 1210.36 678.538V692.268C1210.37 692.333 1210.35 692.397 1210.32 692.454C1210.29 692.511 1210.24 692.558 1210.18 692.591C1210.12 692.624 1210.06 692.642 1209.99 692.642C1209.92 692.642 1209.86 692.624 1209.8 692.591L1207.51 691.299C1207.34 691.204 1207.15 691.154 1206.96 691.154C1206.77 691.154 1206.58 691.204 1206.41 691.299L1197.28 696.466C1197.12 696.564 1196.98 696.703 1196.88 696.87C1196.78 697.037 1196.73 697.226 1196.73 697.417V707.754C1196.73 707.943 1196.78 708.129 1196.88 708.292C1196.98 708.456 1197.12 708.592 1197.28 708.686L1206.41 713.855C1206.58 713.95 1206.77 714 1206.96 714C1207.15 714 1207.34 713.95 1207.51 713.855L1216.64 708.686C1216.81 708.592 1216.95 708.456 1217.04 708.292C1217.14 708.129 1217.19 707.943 1217.19 707.754V681.986C1217.19 681.793 1217.14 681.603 1217.04 681.436C1216.94 681.269 1216.8 681.13 1216.63 681.035L1211.19 678.055C1211.11 678.013 1211.01 677.994 1210.92 678ZM1152.17 690.903C1152 690.904 1151.83 690.947 1151.68 691.028L1142.55 696.197C1142.38 696.291 1142.24 696.427 1142.15 696.591C1142.05 696.755 1142 696.941 1142 697.13L1142.02 711.002C1142.02 711.097 1142.04 711.19 1142.09 711.272C1142.14 711.354 1142.21 711.422 1142.29 711.468C1142.38 711.517 1142.47 711.543 1142.57 711.543C1142.66 711.543 1142.76 711.517 1142.84 711.468L1148.26 708.418C1148.43 708.324 1148.57 708.188 1148.67 708.025C1148.77 707.861 1148.82 707.675 1148.83 707.485V701.007C1148.83 700.818 1148.88 700.632 1148.97 700.468C1149.07 700.304 1149.21 700.168 1149.37 700.074L1151.68 698.764C1151.85 698.67 1152.04 698.62 1152.23 698.62C1152.42 698.62 1152.61 698.67 1152.78 698.764L1155.08 700.074C1155.25 700.168 1155.39 700.304 1155.49 700.468C1155.58 700.632 1155.63 700.818 1155.63 701.007V707.485C1155.64 707.675 1155.69 707.861 1155.79 708.024C1155.89 708.188 1156.03 708.324 1156.2 708.418L1161.62 711.469C1161.7 711.518 1161.8 711.544 1161.89 711.544C1161.99 711.544 1162.08 711.518 1162.17 711.469C1162.25 711.422 1162.32 711.354 1162.37 711.272C1162.42 711.19 1162.44 711.097 1162.44 711.002L1162.46 697.13C1162.46 696.941 1162.41 696.755 1162.31 696.591C1162.22 696.427 1162.08 696.291 1161.91 696.197L1152.78 691.028C1152.63 690.946 1152.46 690.903 1152.28 690.903H1152.17ZM1234.23 691.028C1234.04 691.028 1233.85 691.078 1233.68 691.172L1224.55 696.34C1224.38 696.435 1224.24 696.571 1224.15 696.735C1224.05 696.898 1224 697.084 1224 697.273V707.61C1224 707.8 1224.06 707.987 1224.15 708.151C1224.25 708.315 1224.39 708.45 1224.56 708.543L1233.62 713.604C1233.79 713.697 1233.97 713.748 1234.16 713.752C1234.35 713.755 1234.54 713.71 1234.7 713.621L1240.19 710.625C1240.28 710.579 1240.35 710.512 1240.4 710.43C1240.46 710.348 1240.48 710.254 1240.49 710.158C1240.49 710.063 1240.46 709.97 1240.41 709.888C1240.37 709.806 1240.3 709.738 1240.21 709.691L1231.03 704.523C1230.94 704.474 1230.87 704.403 1230.82 704.318C1230.76 704.233 1230.74 704.137 1230.73 704.038V700.809C1230.74 700.713 1230.77 700.619 1230.82 700.537C1230.87 700.455 1230.94 700.388 1231.03 700.342L1233.88 698.727C1233.96 698.679 1234.06 698.654 1234.16 698.654C1234.25 698.654 1234.35 698.679 1234.43 698.727L1237.29 700.342C1237.37 700.389 1237.44 700.457 1237.49 700.539C1237.53 700.621 1237.56 700.714 1237.56 700.809V703.355C1237.56 703.45 1237.59 703.543 1237.63 703.624C1237.68 703.706 1237.75 703.774 1237.83 703.821C1237.92 703.868 1238.01 703.893 1238.11 703.893C1238.21 703.893 1238.3 703.869 1238.38 703.821L1243.85 700.7C1244.02 700.605 1244.16 700.47 1244.26 700.306C1244.35 700.143 1244.41 699.957 1244.41 699.768V697.274C1244.41 697.085 1244.36 696.899 1244.26 696.735C1244.16 696.571 1244.02 696.435 1243.86 696.34L1234.78 691.172C1234.61 691.077 1234.42 691.028 1234.23 691.029L1234.23 691.028ZM1206.93 698.745C1206.98 698.745 1207.03 698.757 1207.07 698.781L1210.2 700.557C1210.25 700.58 1210.28 700.614 1210.31 700.655C1210.33 700.696 1210.35 700.742 1210.35 700.79V704.343C1210.35 704.392 1210.33 704.438 1210.31 704.479C1210.28 704.52 1210.25 704.554 1210.2 704.577L1207.07 706.354C1207.03 706.377 1206.98 706.389 1206.94 706.389C1206.89 706.389 1206.84 706.377 1206.8 706.354L1203.67 704.577C1203.63 704.554 1203.59 704.52 1203.56 704.479C1203.54 704.438 1203.52 704.391 1203.52 704.343V700.79C1203.53 700.742 1203.54 700.696 1203.56 700.655C1203.59 700.614 1203.63 700.58 1203.67 700.557L1206.8 698.781C1206.84 698.757 1206.88 698.745 1206.93 698.745V698.745Z"
        fill="#404137"
      />
      <path
        d="M1179.6 690.975C1179.41 690.974 1179.22 691.024 1179.06 691.119L1169.92 696.269C1169.76 696.367 1169.62 696.507 1169.52 696.673C1169.42 696.84 1169.37 697.029 1169.38 697.22V707.556C1169.37 707.746 1169.43 707.931 1169.52 708.095C1169.62 708.259 1169.76 708.395 1169.92 708.49L1179.06 713.658C1179.22 713.753 1179.41 713.803 1179.6 713.803C1179.8 713.803 1179.99 713.753 1180.15 713.658L1189.28 708.49C1189.45 708.395 1189.59 708.259 1189.69 708.095C1189.78 707.931 1189.83 707.746 1189.83 707.556V697.22C1189.83 697.028 1189.78 696.84 1189.69 696.673C1189.59 696.506 1189.45 696.367 1189.28 696.269L1180.15 691.121C1179.99 691.026 1179.8 690.976 1179.6 690.977V690.975ZM1234.21 700.2C1234.17 700.197 1234.14 700.203 1234.1 700.218L1232.34 701.223C1232.31 701.241 1232.28 701.267 1232.26 701.298C1232.25 701.33 1232.24 701.366 1232.23 701.402V703.376C1232.24 703.413 1232.25 703.449 1232.26 703.48C1232.28 703.512 1232.31 703.538 1232.34 703.556L1234.1 704.543C1234.13 704.561 1234.17 704.571 1234.2 704.571C1234.24 704.571 1234.27 704.561 1234.3 704.543L1236.06 703.555C1236.09 703.537 1236.12 703.511 1236.14 703.48C1236.16 703.449 1236.17 703.413 1236.17 703.376V701.401C1236.17 701.365 1236.16 701.329 1236.14 701.297C1236.12 701.266 1236.09 701.24 1236.06 701.222L1234.3 700.217C1234.27 700.201 1234.24 700.195 1234.21 700.199L1234.21 700.2Z"
        fill="#83CD29"
      />
    </g>
    <path
      d="M1296 389L1538 389L1538 431M1538 431L1528.38 419.375M1538 431L1547.62 419.375"
      stroke="#181A1B"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_9636"
        x="560"
        y="284"
        width="776"
        height="510"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_9636" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_9636"
          result="effect2_dropShadow_1112_9636"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_9636"
          result="effect3_dropShadow_1112_9636"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_9636"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_9636"
        x1="1662"
        y1="439"
        x2="1414"
        y2="687"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21627" stopColor="#FFE600" />
        <stop offset="0.597222" stopColor="#FD6A00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_9636"
        x1="1642"
        y1="459"
        x2="1434"
        y2="667"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21627" stopColor="#FFE600" />
        <stop offset="0.597222" stopColor="#FD6A00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_9636"
        x1="1618"
        y1="515"
        x2="1453.81"
        y2="577.317"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.166667" stopColor="#FFE600" />
        <stop offset="0.84375" stopColor="#FD6A00" />
      </linearGradient>
      <clipPath id="clip0_1112_9636">
        <rect width="130" height="36" fill="white" transform="translate(1142 678)" />
      </clipPath>
    </defs>
  </svg>
);

Node.propTypes = {
  className: PropTypes.string,
};

Node.defaultProps = {
  className: null,
};

export default Node;
